export const daDataToken = '273932c9ab591a0c8cafaff9b5a9437a4c452b82';
